export type IFilterType =
	| "dropdownCustom"
	| "dropdownCustomExclude"
	| "dropdown"
	| "dropdownExclude"
	| "isEmpty"
	| "isNotEmpty"
	| "isIn"
	| "isNotIn"
	| "textContains"
	| "textDoesNotContain"
	| "textStartsWith"
	| "textEndsWith"
	| "textIsExactly"
	| "greaterEqual"
	| "lessEqual"
	| "between";

export const IFilterTypeAsValues = [
	"dropdownCustom",
	"dropdownCustomExclude",
	"dropdown",
	"dropdownExclude",
	"isEmpty",
	"isNotEmpty",
	"isIn",
	"isNotIn",
	"textContains",
	"textDoesNotContain",
	"textStartsWith",
	"textEndsWith",
	"textIsExactly",
	"greaterEqual",
	"lessEqual",
	"between",
];

export const ITextFilterType = [
	"textContains",
	"textDoesNotContain",
	"textStartsWith",
	"textEndsWith",
	"textIsExactly",
];

export const IBooleanFilterType = ["isEmpty", "isNotEmpty", "isIn", "isNotIn"];

export const INumericFilterType = ["greaterEqual", "lessEqual", "between"];

export interface IFilter {
	name: string;
	filterParam: string;
	subSelectFilterParam?: string;
	filterByType: IFilterType[];
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	filterByValue: any[];
	customColumnId?: number;
	information?: string;
}

export interface IPersonaCategoryFilter {
	name: string;
	filterParam: string;
	subSelectFilterParam?: string;
	filterByType: IFilterType;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	filterByValue: any[];
	customColumnId?: number;
}

export const excludeTitle: IPersonaCategoryFilter = {
	name: "title",
	filterParam: "prospect.title",
	filterByType: "dropdownCustomExclude",
	filterByValue: [],
};

export const includeTitle: IPersonaCategoryFilter = {
	name: "title",
	filterParam: "prospect.title",
	filterByType: "dropdownCustom",
	filterByValue: [],
};

export const ScoringPersonaCategoryFiltersConfig: IPersonaCategoryFilter[] = [
	excludeTitle,
	includeTitle,
];

export interface IPersonaCategoryFilterWithValues {
	[key: string]: {
		value?:
			| string
			| number
			| number[]
			| {
					name: string;
					id: number;
			  }[]
			| {
					title: string;
					id: string;
			  }[]
			| {
					name: string;
					id: number;
			  }
			| {
					from?: number;
					till?: number;
			  };
		filterParam: string;
		type: IFilterType;
		customColumnId?: number;
		name: string;
	};
}
